const SOCAIL_VISIBILITY_MAP = {
    likes: ['VK', 'FB', 'IG', 'TG'],
    lr: ['VK', 'FB', 'IG', 'TG'],
    ir: ['VK', 'FB', 'IG'],
    reposts: ['VK', 'FB', 'IG', 'TG'],
    comments: ['VK', 'FB', 'IG', 'TG'],
    tr: ['VK', 'FB', 'IG', 'TG'],
    erPost: ['VK', 'FB', 'IG', 'TG'],
    erDay: ['VK', 'FB', 'IG', 'TG'],
    views: ['VK', 'IG', 'TG'],
    erView: ['VK', 'IG', 'TG'],
    err: ['VK', 'FB', 'IG', 'TG'],
    vrPost: ['VK', 'IG', 'TG'],
    vrDay: ['VK', 'IG', 'TG'],
    er_progressive: ['VK', 'FB', 'IG', 'TG']
}

function visibilityByPage(type, social) {
    return SOCAIL_VISIBILITY_MAP[type].indexOf(social) >= 0
}

// export const visibilityByPages = (type, pages) => pages.some(page => SOCAIL_VISIBILITY_MAP[type].indexOf(page.social) >= 0);

function visibilityByPages(type, pages) {
    // If only pages argument is provided, assume er_progressive type
    if (!pages) {
        pages = type;
        type = 'er_progressive';
    }
    
    if (!Array.isArray(pages)) return false;
    if (!SOCAIL_VISIBILITY_MAP[type]) return false;
    
    return pages.some(page => SOCAIL_VISIBILITY_MAP[type].indexOf(page.social) >= 0)
}

function visibilityByAdminPage({ isAdmin }) {
    return !!isAdmin
}

function visibilityByAdminPages(pages) {
    if (!Array.isArray(pages)) return false;
    return pages.some(page => !!page.isAdmin)
}

export default {
  visibilityByPage,
  visibilityByPages,
  visibilityByAdminPage,
  visibilityByAdminPages,
};
